<div class="data-table__wrap">
	<div class="d-flex flex-column gap-4 modal_container" id="my-store_info">
		<div class="add_discount_modal-header">
			<h3 class="fs-24 mb-0" i18n="@@store.add_delivery_time">Add delivery discount</h3>
			<svg class="closeModal" xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none" (click)="activeModal.dismiss()">
				<path d="M24 8.5L8 24.5M8 8.5L24 24.5" stroke="#646464" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			</svg>
		</div>

		<form [formGroup]="form" class="fieldgroup edit w-100" (ngSubmit)="submit()" [attr.id]="formId" #formRef="ngForm">
			<div class="checked_expand_block">
				<div class="user_info_container">
					<div class="d-flex flex-column gap-4">
						<div class="user_info_container input_wrapper">
							<h3 class="w-100 mb-2">
								<div class="d-flex gap-2 align-items-start pointer">
									<div i18n="@@store.define_delivery_discount">Define delivery discount</div>
									<div class="required-star">*</div>
								</div>
							</h3>
							<div class="checked_expand_block-row pl-4 flex-column">
								<div class="d-flex flex-row gap-4 radius-control flex-none-column align-items-none-start">
									<div class="input_wrapper max-w-500 w-none-100">
										<div class="delivery_radius_container"> 
											<div class="delivery_radius_wrapper">
												<div class="delivery_radius_range_wrapper">
													<input class="p-0 delivery-radius-slider h-4" type="range" (change)="deliveryDiscount($event.target.value)" formControlName="delivery_discount" min="{{ minValue }}" max="{{ maxValue }}">
													<div class="d-flex align-items-center w-100 justify-content-between">
														<span class="min-value"><img src='/images/icons/sar_symbol_black.svg' loading="lazy"> {{ minValue }}</span>
														<span class="max-value"><img src='/images/icons/sar_symbol_black.svg' loading="lazy"> {{ maxValue }}</span>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="input_wrapper max-w-150  d-flex align-items-end">
										<fieldset class="" [ngClass]="{'has-error': isSubmitted && form.controls.delivery_discount.errors}">
											<label for="deliveryDiscountValue" class="input-after unit"><img src='/images/icons/sar_symbol_black.svg' loading="lazy"></label>
											<input type="number" id="deliveryDiscountValue" formControlName="delivery_discount" (change)="deliveryDiscount($event.target.value)" min="{{ minValue }}" max="{{ maxValue }}" value="{{ minValue }}" class="radius-input delivery-radius-value" appPreventScroll>
											<span class="field-error no-label" *ngIf="form.controls.delivery_discount.errors?.required" i18n="@@error.required">Required</span>
											<span class="field-error" *ngIf="(form.controls.delivery_discount.dirty) && ( form.controls.delivery_discount.errors?.max || form.controls.delivery_discount.errors?.min)" i18n="@@error.invalid_number" >Invalid</span>
										</fieldset>
									</div>
								</div>
							</div>
						</div>

						<div class="user_info_container gap-3 mt-2">
							<h3 class="w-100 mb-2">
								<div class="d-flex gap-2 align-items-start pointer" i18n="@@store.discount_applies_during">
									Discount applies during						
								</div>
							</h3>
							<div class="d-flex align-items-center justify-content-between">										
								<div class="d-flex align-items-center gap-4 m-0 justify-none-between w-none-100">
									<div class="d-flex flex-column gap-1">
										<ng-container *ngFor="let day of selectedWeekDays | keyvalue">
											<div class="d-flex align-items-start gap-4 m-0" *ngIf="day.value.available == true">
												<span class="">{{ day.key | titlecase }}</span>
												<div class="d-flex flex-column gap-1">
													<span>{{ newFormatHoursMin(day.value.start_time) }} to {{ newFormatHoursMin(day.value.end_time) }}</span>
												</div>
											</div>
										</ng-container>
									</div>
									<a href="javascript:;" class="secondary_btn small editOpeningHours d-none-none" (click)="editDiscountDuration('careem')">
										<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
											<path d="M18 10.0003L14 6.0003M2.5 21.5003L5.88437 21.1243C6.29786 21.0783 6.5046 21.0553 6.69785 20.9928C6.86929 20.9373 7.03245 20.8589 7.18289 20.7597C7.35245 20.6479 7.49955 20.5008 7.79373 20.2066L21 7.0003C22.1046 5.89573 22.1046 4.10487 21 3.0003C19.8955 1.89573 18.1046 1.89573 17 3.0003L3.79373 16.2066C3.49955 16.5008 3.35246 16.6478 3.24064 16.8174C3.14143 16.9679 3.06301 17.131 3.00751 17.3025C2.94496 17.4957 2.92198 17.7024 2.87604 18.1159L2.5 21.5003Z" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
										</svg>
										<span i18n="@@common.edit">Edit</span>
									</a>
									<svg class="d-none-block editOpeningHours" (click)="editDiscountDuration('careem')" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
										<rect width="36" height="36" rx="8" fill="#EB1461" fill-opacity="0.1"/>
										<path d="M24 16.0003L20 12.0003M8.5 27.5003L11.8844 27.1243C12.2979 27.0783 12.5046 27.0553 12.6978 26.9928C12.8693 26.9373 13.0324 26.8589 13.1829 26.7597C13.3525 26.6479 13.4995 26.5008 13.7937 26.2066L27 13.0003C28.1046 11.8957 28.1046 10.1049 27 9.0003C25.8955 7.89573 24.1046 7.89573 23 9.0003L9.79373 22.2066C9.49955 22.5008 9.35246 22.6478 9.24064 22.8174C9.14143 22.9679 9.06301 23.131 9.00751 23.3025C8.94496 23.4957 8.92198 23.7024 8.87604 24.1159L8.5 27.5003Z" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
								</div>
							</div>
						</div>
					</div>

					<div class="user_info_container gap-1 mt-2">
						<h3 class="mb-2" i18n="@@store.discount_expiration_datetime">
							Discount expiration date and time
						</h3>
						<div class="d-flex align-items-center justify-content-between flex-none-column align-items-none-start gap-3">
							<div class="date_wrap w-100">
								<div class="field_cont">
									<fieldset class="date sl m-0" [ngClass]="{'has-error': isSubmitted && form.controls.discount_expiry.errors && form.controls.discount_expiry.errors.required}">
										<label i18n="@@store.date">
											Select Date
										</label>
										<div class="date-input-wrap">
											<input date-dropper data-dd-format="Y-m-d" data-large-default="true" class="date-input datedropper-init" data-theme="teamup" id="paymentDate" formControlName="discount_expiry" placeholder="Select Date" />
										</div>
										<span class="field-error" *ngIf="form.controls.discount_expiry.errors?.required" i18n="@@error.required">Required</span>
									</fieldset>
								</div>
							</div>
							<div class="w-100 w-none-100">
								<!-- <div class="time-picker h-48"> -->

									<fieldset class="" [ngClass]="{ 'has-error': isSubmitted && expiryTimeGroup?.invalid }">
										<label i18n="@@store.time" class="pt-3">
											Select Time
										</label>
										<div formGroupName="discount_expiry_time_group"  class="timing opening">
											<div class="input-wrapper">
												<fieldset class="hours">
													<select nice-select data-placeholder="H" formControlName="hours" (change)="onChangeExpiryTime()">
														<option *ngFor="let i of hours" [value]="i"> {{ i }} </option>
													</select>
													<!-- <span>H</span> -->
												</fieldset>

												<fieldset class="minutes">
													<select nice-select data-placeholder="M" formControlName="minutes" (change)="onChangeExpiryTime()" class="minutes">
														<option *ngFor="let i of minutes" [value]="i"> {{ i }} </option>
													</select>
													<!-- <span>M</span> -->
												</fieldset>
											</div>
										</div>
										<span class="field-error" *ngIf="isSubmitted && expiryTimeGroup?.errors?.required" i18n="@@error.required.opening_time">Opening time is required</span>
									</fieldset>

									<!-- <input placeholder="Select time" type="text" class="time-input" readonly>
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
										<path d="M6 9L12 15L18 9" stroke="#0A0A0A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
									<div class="time-dropdown" style="display: none;">
									</div> -->
								<!-- </div> -->
							</div>
						</div>
					</div>

					<div class="d-flex mt-2 gap-3 flex-none-column align-items-none-start">
						<fieldset class="half" [ngClass]="{'has-error': isSubmitted && form.controls.minimum_order_size.errors}">
							<div class="input_wrapper w-none-100">
								<label for="minimumordersize" class="fs-16 fw-600 mb-4 color-393939" i18n="@@store.minimum_order_size">
									Minimum order size
								</label><span class="required-star">*</span>
								<label for="minimumordersize" class="input-after"><img src='/images/icons/sar_symbol_black.svg' loading="lazy"></label>
								<input type="number" id="minimumordersize" formControlName="minimum_order_size" (change)="updateMinValidation()" appPreventScroll>
								<span class="field-error" *ngIf="form.controls.minimum_order_size.errors?.required" i18n="@@error.required" style="top: 90%;">Required</span>									
								<span class="field-error" *ngIf="(form.controls.minimum_order_size.dirty) && ( form.controls.minimum_order_size.errors?.max || form.controls.minimum_order_size.errors?.min)" i18n="@@error.invalid_number" >Invalid</span>
							</div>
						</fieldset>
						<fieldset class="half" [ngClass]="{'has-error': isSubmitted && form.controls.minimum_discount_size.errors}">
							<div class="input_wrapper w-none-100">
								<label for="minimumordersizediscount" class="fs-16 fw-600 mb-4 color-393939" i18n="@@store.minimum_order_size_to_get_discount">
									Minimum order size to get the discount
								</label><span class="required-star">*</span>
								<label for="minimumordersizediscount" class="input-after"><img src='/images/icons/sar_symbol_black.svg' loading="lazy"></label>
								<input type="number" id="minimumordersizediscount" formControlName="minimum_discount_size" (change)="updateMinValidation()" appPreventScroll>
								<span class="field-error" *ngIf="form.controls.minimum_discount_size.errors?.required" i18n="@@error.required" style="top: 90%;">Required</span>
								<span class="field-error" *ngIf="(form.controls.minimum_discount_size.dirty) && ( form.controls.minimum_discount_size.errors?.max || form.controls.minimum_discount_size.errors?.min)" i18n="@@error.invalid_number" >Invalid</span>
							</div>
						</fieldset>
					</div>
				</div>
			</div>

			<div class="d-flex w-100 align-items-center justify-content-end mt-2">
				<button type="button" form="ngForm" (click)="formRef.ngSubmit.emit()" class="primary_btn small w-160 saveWorkingHours" i18n="@@ts.save">Save</button>
			</div>
		</form>
	</div>
</div>